export const ListOfAdminCodes: string[] = [
  '01',
  '02',
  '03',
  '04',
  '08',
  '10',
  '11',
  '14',
  '28',
  '1006',
  '1104',
  '1106',
  '1108',
  '1109',
  '1125',
  '1126',
  '1130',
  '1131',
  '1141',
  '1143',
  '1150',
  '1202',
  '1205',
  '1319',
  '1601',
  '1602',
  '1603',
  '1604',
  '1605'];
